import React from 'react';

const Bar: React.FC = ( ) => {
  return (
    <hr className="h-1 bg-orange-base rounded-full w-full border-none" />
  );
};

export default Bar;
